import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCakephpComponent } from './simple-icons-cakephp.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCakephpComponent ],
    exports:      [ SimpleIconsCakephpComponent ],
    bootstrap:    []
})
export class SimpleIconsCakephpModule {}
